import { useRef, useState, useEffect } from 'react'
import b64toBlob from 'b64-to-blob'
import Cropper from 'react-cropper'
import Icon from '@components/shared/Icon'
import SpinnerBlock from '@components/spinner/SpinnerBlock'
import useT from '@hooks/useTranslation'
import 'cropperjs/dist/cropper.css'

const DEFAULT_RATIO = 263 / 175

const ImageEditor = ({ src, callback, imageAspectRatio = DEFAULT_RATIO }) => {
    if (!src) return null

    const cropperRef = useRef(null)
    const [busy, setBusy] = useState(false)
    const [rotation, setRotation] = useState(0)

    useEffect(() => {
        const image = cropperRef?.current
        const cropper = image?.cropper
        if (cropper) cropper.rotateTo(rotation)
    }, [rotation])

    const left = () => setRotation(rotation - 45)
    const right = () => setRotation(rotation + 45)
    const cancel = () => callback(null)
    const done = () => {
        setBusy(true)
        const image = cropperRef?.current
        const cropper = image?.cropper
        if (!cropper) return

        const base64 = cropper.getCroppedCanvas().toDataURL()
        const type = base64.slice(5, base64.indexOf(';'))
        const blob = b64toBlob(base64.split('base64,')[1], type)
        setBusy(false)
        callback(blob)
    }

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <h2>{useT('Dokonaj edycji zdjęcia')}</h2>
            <Cropper src={src} ref={cropperRef}
                aspectRatio={imageAspectRatio}
                zoomOnWheel={false}
                className="cropper-container" />

            <br />
            {
                busy
                ? <SpinnerBlock height={50} small />
                : <div>
                    <span onClick={left} className="clickable"><Icon>rotate_left</Icon></span>
                    <span onClick={right} className="clickable"><Icon>rotate_right</Icon></span>
                    <span onClick={cancel} className="clickable"><Icon>close</Icon></span>
                    <span onClick={done} className="clickable"><Icon>done</Icon></span>
                  </div>
            }
        </div>
    )
}

export default ImageEditor